import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { chamarApi } from '@/nucleo/auth/cliente-api';
import { naoInsistirEmRecusa } from '@/nucleo/naoInsistirEmRecusa';

import type { FiltroDeEmails, ListaDeEmails } from './contrato';

/**
 * Camada de dados do monitoramento de e-mails. Dado real, da API
 * (`bff/v1/admin/comunicacao/emails`): a lista junta a fila de envio e o
 * registro de envio, e o endereço do destinatário chega mascarado.
 */
export const CAMINHO_DOS_EMAILS = '/bff/v1/admin/comunicacao/emails';

export const CHAVES = {
  emails: (filtro: FiltroDeEmails) => ['admin', 'comunicacao', 'emails', filtro] as const,
};

function consultaDosEmails(filtro: FiltroDeEmails): string {
  const consulta = new URLSearchParams({
    periodo: filtro.periodo,
    pagina: String(filtro.pagina),
    tamanho: String(filtro.tamanho),
  });
  if (filtro.situacao) consulta.set('situacao', filtro.situacao);
  if (filtro.evento) consulta.set('evento', filtro.evento);
  if (filtro.busca.trim()) consulta.set('busca', filtro.busca.trim());
  return `${CAMINHO_DOS_EMAILS}?${consulta.toString()}`;
}

export function useEmailsEnviados(filtro: FiltroDeEmails) {
  return useQuery({
    queryKey: CHAVES.emails(filtro),
    queryFn: ({ signal }) => chamarApi<ListaDeEmails>(consultaDosEmails(filtro), { sinal: signal }),
    // Trocar filtro ou página não pode esvaziar a tabela entre uma resposta e outra.
    placeholderData: keepPreviousData,
    retry: naoInsistirEmRecusa,
  });
}
